import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@gray/domain/http/api.service';
import { ECoachTicketUrgency } from '../enums/ticket-urgency.enum';

@Injectable({providedIn: 'root'})
export class CoachTicketService {

  private apiPrefix = '/coach/tickets';

  constructor(
    private api: ApiService,
  ) {
  }

  /** The tag dictionary a ticket is classified with; maintained in the admin panel. */
  getTags(): Observable<any> {
    return this.api.get(`${this.apiPrefix}/tags`);
  }

  getTickets(queryString = ''): Observable<any> {
    return this.api.get(`${this.apiPrefix}`, queryString);
  }

  getTicket(ticketId: number): Observable<any> {
    return this.api.get(`${this.apiPrefix}/${ticketId}`);
  }

  createTicket(
    data: { title: string, urgency: ECoachTicketUrgency, message: string, tagIds: number[] },
  ): Observable<any> {
    return this.api.post(`${this.apiPrefix}`, data);
  }

  addMessage(ticketId: number, body: string): Observable<any> {
    return this.api.post(`${this.apiPrefix}/${ticketId}/messages`, {body});
  }

  closeTicket(ticketId: number): Observable<any> {
    return this.api.patch(`${this.apiPrefix}/${ticketId}/close`, {});
  }
}
